import React, { ReactElement, useContext, useState } from "react";
import { authContext } from "../Context/Authentication/authContext";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./Login.scss";
import {
  Button,
  IconButton,
  InputAdornment,
  OutlinedInput,
  FormControl,
  Typography,
  FormHelperText,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import credentials from "./Credentials.json";
import { Bars } from "react-loader-spinner";
import { generateDropDownRanges } from "../Helpers/helpers";
import { baseURL, dataScienceURL, otherBaseURL } from "../config";
import { error } from "console";
import {
  TrackingEvents,
  useAnalytics,
} from '../Context/Analytics.context'

export default function Login(): ReactElement {
  const navigate = useNavigate();
  const { dispatch, state }: any = useContext(authContext);
  const [showError, setShowError] = useState(false);
  const [showEmptyError, setShowEmptyError] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [isSignUp, setIsSignUp] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [userPwd, setUserPwd] = useState("");
  const [userConfirmPwd, setUserConfirmPwd] = useState("");
  const [showPassword, setShowPassword] = React.useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [errorMsg, setErrorMessage] = useState("");
  const { track } = useAnalytics();

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleClickShowConfirmPassword = () => setShowConfirmPassword((show) => !show);
  const login = async () => {
    setShowError(false)
    setShowConfirmation(false)
    if(!isSignUp){
      if (email === '' || userPwd === '') {
        setShowError(true);
        setErrorMessage('😕 Please fill out the empty fields')
        return;
      }
      const payload:any =   {
        "email": email.toLowerCase(),
        "password": userPwd
      }
      const response = await axios.post(`${otherBaseURL}login`,payload).then(async (response:any)=>{
        console.log(response)
        const userDetails = await axios.get(`${otherBaseURL}/userInfo?email=${email.toLowerCase()}`);
        console.log(userDetails)

        track(TrackingEvents['userLoggedIn'], {
          email:email ,
        });

        const user =   {
          "username": userDetails.data.firstname.charAt(0).toUpperCase() + userDetails.data.firstname.slice(1),
          "password": userPwd,
          "email": email,
          "firstname":userDetails.data.firstname,
          "lastname":userDetails.data.lastname,
          "role":userDetails.data.role

        }
        setLoading(true);
        // const predictionTill = await generateDropDownRanges();
        // console.log(predictionTill)
        localStorage.setItem('isLoggedIn', JSON.stringify(true));
        localStorage.setItem('user', JSON.stringify(user));
        dispatch({
          type: 'IS_AUTHENTICATED',
          payload: true,
        });
        dispatch({
          type: 'SET_USER',
          payload: user,
        });
        // dispatch({
        //   type: 'APPLY_FILTER',
        //   payload: {
        //     ...state.filters,
        //     predictionTill,
        //   },
        // });
        navigate('/');
   

      }).catch((error)=>{
        console.log(error)
        setShowError(true);
        setErrorMessage(`${error.response.data.message}`);
        
      });
      console.log(response)
      
    
      // if(response.data){
        // const userDetails = await axios.get(`${dataScienceURL}/userInfo?email=${email.toLowerCase()}`);
        // console.log(userDetails)

        // const user =   {
        //   "username": userDetails.data.firstname,
        //   "password": userPwd,
        //   "email": email,

        // }
        // setLoading(true);
        // const predictionTill = await generateDropDownRanges();
        // localStorage.setItem('isLoggedIn', JSON.stringify(true));
        // localStorage.setItem('user', JSON.stringify(user));
        // dispatch({
        //   type: 'IS_AUTHENTICATED',
        //   payload: true,
        // });
        // dispatch({
        //   type: 'SET_USER',
        //   payload: user,
        // });
        // dispatch({
        //   type: 'APPLY_FILTER',
        //   payload: {
        //     ...state.filters,
        //     predictionTill,
        //   },
        // });
        // navigate('/');
  
      // }
      // if(!response.data){
        // setShowError(true);
        // setErrorMessage('😕 Username/password is incorrect')
        // return;
  
      // }

    }
    else{
      if (firstName === '' || userPwd === '' || email===''  || userConfirmPwd==='') {

        setShowError(true);
        setShowEmptyError(true)
        setErrorMessage('😕 Please fill out the empty fields')
        return;
      }
      else if(userPwd !== userConfirmPwd){

        setShowError(true);
        setShowEmptyError(true)
        setErrorMessage('😕 Password MisMatched')
        return;

      }
      const userDetails={
        "firstname": firstName,
        "lastname": lastName,
        "email": email.toLowerCase(),
        "password": userPwd
    }
    setLoading(true)
      const response = await axios.post(`${otherBaseURL}register`,userDetails).then((responce)=>{
        console.log(responce)
        setShowConfirmation(true)
        setLoading(false)

      }).catch((error)=>{
        console.log(error)
        setShowError(true);
        setErrorMessage('😕 Username/Email already exists')
        setLoading(false)
        
      })
      console.log(response)
      // if(response.data){
      //   setShowConfirmation(true)
      //   return;

      // }
      // if(!response.data){
        // setShowError(true);
        // setErrorMessage('😕 Username/Email already exists')
      //   return;
  
      // }
      
      // const user = credentials?.find(
      //   ({ username }) => username.toLowerCase() === userName.toLowerCase()
      // );
      // if(response.data){
      //   const user =   {
      //     "username": userName,
      //     "password": userPwd
      //   }
      //   setLoading(true);
      //   const predictionTill = await generateDropDownRanges();
      //   localStorage.setItem('isLoggedIn', JSON.stringify(true));
      //   localStorage.setItem('user', JSON.stringify(user));
      //   dispatch({
      //     type: 'IS_AUTHENTICATED',
      //     payload: true,
      //   });
      //   dispatch({
      //     type: 'SET_USER',
      //     payload: user,
      //   });
      //   dispatch({
      //     type: 'APPLY_FILTER',
      //     payload: {
      //       ...state.filters,
      //       predictionTill,
      //     },
      //   });
      //   navigate('/');
  
      // }
      // if(!response.data){
      //   setShowError(true);
      //   return;
  
      // }
    }
   
    
  };

  // const login = async () => {
  //   if (userName === "" || userPwd === "") {
  //     setShowError(true);
  //     return;
  //   }
  //   const user = credentials?.find(
  //     ({ username }) => username.toLowerCase() === userName.toLowerCase()
  //   );
  //   if (!user) {
  //     setShowError(true);
  //     return;
  //   }
  //   if (user?.password === userPwd) {
  //     setLoading(true);
  //     const predictionTill = await generateDropDownRanges();
  //     localStorage.setItem("isLoggedIn", JSON.stringify(true));
  //     localStorage.setItem("user", JSON.stringify(user));

  //     dispatch({
  //       type: "IS_AUTHENTICATED",
  //       payload: true,
  //     });
  //     dispatch({
  //       type: "SET_USER",
  //       payload: user,
  //     });
  //     dispatch({
  //       type: "APPLY_FILTER",
  //       payload: {
  //         ...state.filters,
  //         predictionTill,
  //       },
  //     });
  //     navigate("/");
  //   } else {
  //     setShowError(true);
  //   }
  // };

  const handleInputChange = (ev: any) => {
  
    if (ev.target.name === "firstName") {
      setShowError(false);
      setFirstName(ev.target.value);
    }
    else   if (ev.target.name === "lastName") {
      setShowError(false);
      setLastName(ev.target.value);
    }  
    else if (ev.target.name === "email") {
      setShowError(false);
      setEmail(ev.target.value);
    } 
    else if (ev.target.name === "confirmPassword") {
      setShowError(false);
      setUserConfirmPwd(ev.target.value);
    } 

    else {
      setShowError(false);
      setUserPwd(ev.target.value);
    }
  };

  const handleSignUp=()=>{
    setShowError(false)
    setShowConfirmation(false)
    setIsSignUp(!isSignUp)

  }
  const handleReset=()=>{
    console.log("dfgh")
    navigate("/resetPassword")
  }

  return (
    <div className="ftLogin">
      <div className="ftLogin_leftContainer">
        <div className={"ftLogin_leftContainer_text"}>
          <div className={"ftLogin_leftContainer_text_1"}>
            <b>Estate Intel 1.0</b>
          </div>
          <div className={"ftLogin_leftContainer_text_3"}>
            Building Bridges to the <b>future</b> through{" "}
            <b>smart technologies</b> and <b>smarter construction.</b>
          </div>
        </div>
      </div>
      <div>
        <div className={"ftLogin_container_parent1"}>
          <div className={"ftLogin_container_parent2"}>
            <div className="ftLogin_container">
              <form
                className="ftLogin_container_form"
                onSubmit={(ev) => {
                  ev.preventDefault();
                  login();
                }}
              >
                    <FormControl sx={{ m: 2, width: "95%" }}>
                  <Typography
                    className="ftLogin_container_form_label"
                    gutterBottom
                  >
                    Email*
                  </Typography>
                  <OutlinedInput
                    className="ftLogin_container_form_input"
                    name="email"
                    value={email}
                    onChange={handleInputChange}
                  />
                </FormControl>
                {/* {
                  isSignUp && (
                    <>
                    <FormControl sx={{ m: 2, width: "95%" }}>
                    <Typography
                      className="ftLogin_container_form_label"
                      gutterBottom
                    >
                      First Name*
                    </Typography>
                    <OutlinedInput
                      className="ftLogin_container_form_input"
                      name="firstName"
                      value={firstName}
                      onChange={handleInputChange}
                    />
                  </FormControl><FormControl sx={{ m: 2, width: "95%" }}>
                    <Typography
                      className="ftLogin_container_form_label"
                      gutterBottom
                    >
                      Last Name
                    </Typography>
                    <OutlinedInput
                      className="ftLogin_container_form_input"
                      name="lastName"
                      value={lastName}
                      onChange={handleInputChange}
                    />
                  </FormControl>
                    </>
                  )
                } */}
                <FormControl sx={{ m: 2, width: "95%" }}>
                  <Typography
                    gutterBottom
                    className="ftLogin_container_form_label"
                  >
                    Password*
                  </Typography>

                  <OutlinedInput
                    className="ftLogin_container_form_input"
                    id="outlined-adornment-password"
                    type={showPassword ? "text" : "password"}
                    onChange={handleInputChange}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </FormControl>

                {/* {
                  isSignUp && (
                    <FormControl sx={{ m: 2, width: "95%" }}>
                    <Typography
                      gutterBottom
                      className="ftLogin_container_form_label"
                    >
                      Confirm Password*
                    </Typography>
  
                    <OutlinedInput
                      className="ftLogin_container_form_input"
                      id="outlined-adornment-password"
                      type={showConfirmPassword ? "text" : "password"}
                      onChange={handleInputChange}
                      name="confirmPassword"
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowConfirmPassword}
                            edge="end"
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                  )
                } */}

                <FormControl sx={{ m: 2 }} style={{margin:"12px"}}>
                  <Button
                    variant="outlined"
                    // onClick={() => login()}
                    type="submit"
                    className="ftLogin_container_form_loginButton"
                  >
                    {!isSignUp?'Login':"SignUp"}
                    <Bars
                      height="30"
                      color="#035F77"
                      ariaLabel="bars-loading"
                      wrapperStyle={{ float: "left" }}
                      wrapperClass=""
                      visible={loading}
                    />
                  </Button>
                </FormControl>
                <div className="ftLogin_container_form_signup">
                {/* <FormControl sx={{ m: 1 }}>
                <FormHelperText  id="accountId-error"  onClick={handleSignUp} className="ftLogin_container_form_signup_signuptext">
                        {isSignUp?'Back to Login':''}
                      </FormHelperText>
                </FormControl> */}
              {
                !isSignUp && (
                  <FormControl sx={{ m: 1 }} style={{marginLeft:'12px'}}>
                  <FormHelperText  id="accountId-error" onClick={handleReset} className="ftLogin_container_form_signup_forgotpassword" >
                          Forgot Password?
                        </FormHelperText>
                  </FormControl>
                )
              }

                </div>

                
                {showConfirmation && (
                  <div className="errorContainer">
                    <FormControl sx={{ m: 1 }}>
                      <FormHelperText  id="accountId-error">
                            User Registered Succesfully!
                      </FormHelperText>
                    </FormControl>
                  </div>
                )}

               

                {showError && (
                  <div className="errorContainer">
                    <FormControl sx={{ m: 1 }}>
                      <FormHelperText error id="accountId-error">
                        {errorMsg}
                        {/* {isSignUp?showEmptyError?"😕 Please fill out the empty fields ":"😕 Username/Email already exists":"😕 Username/password is incorrect"} */}
                      </FormHelperText>
                    </FormControl>
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}